<div class="header-wrapper">
  <div class="title-section display-flex-end">
    <div class="header-logo display-flex-end">
      <img class="logo" src="assets/images/color-logo.svg" alt="Logo Siemens" />
      <span class="title">Virtual Point Creator</span>
    </div>
  </div>
  <div class="header-signature display-flex-end">
    <div class="header-right flex-center desktop-nav">
      <ix-toggle
        class="theme-toggle"
        [checked]="themeService.isDarkMode"
        (checkedChange)="themeService.toggleTheme($event.detail)"
        [hidden]="true"
      >
        <ix-icon [name]="themeService.isDarkMode ? 'moon' : 'sun'" size="16"></ix-icon>
      </ix-toggle>
      <ix-icon-button
        class="settings-button"
        icon="cogwheel"
        ghost
        aria-label="Settings"
        #settingsTrigger
      ></ix-icon-button>
      <ix-dropdown [ixDropdownTrigger]="settingsTrigger">
        <div class="settings-menu-item">
          <span>Auto refresh</span>
          <ix-toggle
            [checked]="autoRefreshSettings.enabled"
            (checkedChange)="autoRefreshSettings.setEnabled($event.detail)"
            aria-label="Auto refresh"
          ></ix-toggle>
        </div>
      </ix-dropdown>
      <ix-avatar class="signature" extra="Administrator" [initials]="getInitials(userProfile['name'])" #trigger> </ix-avatar>
      <ix-dropdown [ixDropdownTrigger]="trigger">
        <div class="flex-start">
          <ix-avatar class="signature avatar-sign" extra="Administrator" [initials]="getInitials(userProfile['name'])">
          </ix-avatar>
          <div class="signature-desc">
            <span class="name">{{ userProfile['name'] || '--' }}</span>
            <span class="email">{{ userProfile['email'] || '--' }}</span>
          </div>
        </div>
        <ix-dropdown-item (click)="signOut()">
          <div class="action-icons">
            <ix-icon class="icons" name="log-out" size="16"></ix-icon> Log out
          </div>
        </ix-dropdown-item>
      </ix-dropdown>
    </div>
  </div>
</div>
